import React from 'react';
import { PencilIcon } from '@hero/web-icons';

/**
 * Tiny pencil button rendered next to a field when the current
 * viewer is allowed to edit it. Behaviour is stubbed — `onClick`
 * just calls `console.log` — because the preview is mock-only.
 *
 * Hidden entirely when `canEdit` is `false` so the same row reads
 * cleanly for read-only viewers (e.g. a driver looking at the
 * shipper's price).
 */
export interface EditAffordanceProps {
  canEdit: boolean;
  field: string;
}

export const EditAffordance: React.FC<EditAffordanceProps> = ({
  canEdit,
  field,
}) => {
  if (!canEdit) return null;
  return (
    <button
      type="button"
      onClick={() => console.log(`[orders-preview] edit ${field}`)}
      className="ms-2 inline-flex items-center justify-center rounded-md p-1 text-gray-300 hover:bg-gray-100 hover:text-gray-600 transition-colors"
      aria-label={`Edit ${field}`}>
      <PencilIcon className="size-3.5" />
    </button>
  );
};
